export const getDeliveryIdentifier = (delivery) => (
  delivery?.id || delivery?.orderId || delivery?.deliveryId || 'N/A'
);

export const formatDisplayOrderId = (value) => {
  if (!value) {
    return null;
  }

  const normalizedValue = String(value).trim();

  if (!normalizedValue) {
    return null;
  }

  const compactValue = normalizedValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  if (compactValue.length <= 10) {
    return `ORD-${compactValue}`;
  }

  return `ORD-${compactValue.slice(-10)}`;
};

export const getTimelineBadgeClass = (status) => {
  const statusClassMap = {
    PENDING: 'bg-warning',
    ASSIGNED: 'bg-info',
    PICKED_UP: 'bg-primary',
    DELIVERED: 'bg-success',
  };

  return statusClassMap[status] || 'bg-secondary';
};

export const getStatusCopy = (status) => {
  const copyMap = {
    PENDING: 'Waiting for a driver to accept the delivery.',
    ASSIGNED: 'Driver assigned and preparing for pickup.',
    PICKED_UP: 'Parcel has been collected and is on the move.',
    IN_TRANSIT: 'Your parcel is currently in transit.',
    DELIVERED: 'Delivery completed successfully.',
    CANCELLED: 'This delivery was cancelled.',
  };

  return copyMap[status] || 'Tracking updates will appear here.';
};

export const isDeliveredStatus = (status) => String(status).toUpperCase() === 'DELIVERED';

export const getDeliveryCounts = (deliveries) => ({
  total: deliveries.length,
  active: deliveries.filter((delivery) => delivery.status !== 'DELIVERED' && delivery.status !== 'CANCELLED').length,
  delivered: deliveries.filter((delivery) => delivery.status === 'DELIVERED').length,
});
